import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useStaticQuery, graphql } from 'gatsby';

import config from '../../utils/config';

const Section = styled.nav`
  .navbar-item {
    height: 75px !important;
    text-align: center;
    justify-content: center;

    @media screen and (max-width: 768px) {
      display: flex;
      align-items: center;
    }
  }

  .has-width {
    @media screen and (min-width: 768px) {
      width: 137px !important;
    }
  }

  .navbar-menu {
    @media screen and (max-width: 768px) {
      position: absolute;
      width: 100%;
      transition: 0.6s;
    }
  }

  // Mobile view Hum-burger styling
  .navbar-burger {
    background: ${(props) => props.theme.mainBrandColor};
    color: ${(props) => props.theme.lightShades};
    border-radius: 4px;
    :hover {
      background-color: ${(props) => props.theme.mainBrandColor};
    }
  }

  /* Common css:- overwrite bulma css */
  a.navbar-item:focus,
  a.navbar-item:hover {
    background-color: transparent;
  }
  .has-text-white {
    color: ${(props) => props.theme.lightShades} !important;
  }
  .button {
    width: 100%;
    height: 100%;
  }
`;

// graphql query for header
const query = graphql`
  query HeaderNavigation {
    navigation: sanityNavigation {
      _id
      navLink {
        _key
        label
        secondaryLink {
          current
        }
        target {
          title
          slug {
            current
          }
        }

        showButton
      }
    }
    sanityGlobals {
      logoImage {
        asset {
          url
        }
      }
    }
  }
`;

const Header = () => {
  const { navigation, sanityGlobals } = useStaticQuery(query);
  const [isActive, setIsActive] = useState(false);

  return (
    <Section
      className="section py-1 navbar"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container">
        <div className="navbar-brand">
          {sanityGlobals.logoImage && (
            <Link className="navbar-item" to="/">
              <img
                src={sanityGlobals.logoImage.asset.url}
                alt={`${config.siteName} logo`}
              />
            </Link>
          )}

          <button
            type="button"
            className={`is-align-self-center ${
              isActive ? 'is-active navbar-burger' : 'navbar-burger'
            } `}
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
            onClick={() => setIsActive(!isActive)}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </button>
        </div>

        <div
          className={`${isActive ? 'navbar-menu is-active' : 'navbar-menu'}`}
        >
          <div className="navbar-end">
            {navigation &&
              navigation.navLink.map((el) => {
                if (!el) {
                  return null;
                }
                const slug =
                  el.target && el.target.slug && el.target.slug.current;
                const secondarySlug =
                  el.secondaryLink && el.secondaryLink.current;
                return (
                  <Link
                    key={el._key}
                    to={slug ? `/${slug}/` : `/${secondarySlug}/`}
                    className="navbar-item m-auto has-text-weight-semibold is-size-6 py-0 has-width"
                  >
                    <div
                      className={`has-text-grey-dark ${
                        el.showButton &&
                        'button has-text-white is-medium is-primary is-size-6 is-borderless'
                      }`}
                    >
                      {el.label}
                    </div>
                  </Link>
                );
              })}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Header;
